/**
 * 跳转工具函数
 */
import router from '@/router';

// 获取环境变量
const adminPath = import.meta.env.VITE_ADMIN_PATH;
const workspacePath = import.meta.env.VITE_WORKSPACE_PATH;///workspace
const testHostAdmin = import.meta.env.VITE_TEST_HOST_ADMIN;
const testHostWorkspace = import.meta.env.VITE_TEST_HOST_WORKSPACE;//1818118.iiii.com
/**
 * 根据当前环境打开外部链接
 * @param path 路径
 * @param testHost 测试环境域名
 */
export const openExternalLink = (path: string, testHost: string) => {
  const host = window.location.host;
  // 如果是内网地址,则写全路径
  if (host.includes('192.168') || host.includes('localhost') || host.includes('127.0.0.1')) {
    window.open(`http://${testHost}${path}`);
  } else {
    window.open(`https://${host}${path}`);
  }
};

/**
 * 跳转到工作台
 */
export const goToWorkspace = () => {
  openExternalLink(workspacePath, testHostWorkspace);
};

/**
 * 跳转到ai工具
 */
export const goToAiTool = () => {
  openExternalLink( '/workspace/create/ai-tools',testHostWorkspace);
};

/**
 * 跳转到数字资产
 */
export const goToDigitalAssets = () => {
  openExternalLink( '/workspace/other/recharge-center',testHostWorkspace);
};

/**
 * 跳转到后台管理
 */
export const goToAdmin = () => {
  openExternalLink(adminPath, testHostAdmin);
};

export const checkAndNavigate = (path: string) => {
  const exitRoutes = [
   '/','/welcome','/ai-application-training','/interactive-digital','/interactive-digital-human','/outstanding-cases','/outstanding-case','/customized-model'
  ]
  const routeExists = router.getRoutes().some(route => route.path === path);
  const isExitRoutes = exitRoutes.includes(path);
  if (routeExists || isExitRoutes) {
    // 如果路由存在，使用路由跳转（当前页面跳转）
    router.push(path);
  } else {
    // 如果路由不存在，使用 window.open 在新窗口打开
    const host = window.location.host;
    if (host.includes('192.168') || host.includes('localhost') || host.includes('127.0.0.1')) {
      window.open(`http://${testHostWorkspace}${path}`);
    } else {
      window.open(`https://${host}${path}`);
    }
  }
};
